
import { computed, defineComponent, ref } from "vue";
import AgCard from "@/components/ag-card/index.vue";
import SyslogSetting from "@/helpers/pages/SyslogSetting";
import { useStore } from "@/store";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import Swal from "sweetalert2";
import * as Yup from "yup";
import { Field, Form, ErrorMessage } from "vee-validate";
import Toggle from "@vueform/toggle";
import { mapState } from "vuex";

const store = useStore();

export default defineComponent({
  name: "SyslogSettings",
  data() {
    const schema = Yup.object().shape({
      HostName: Yup.string()
        .required()
        .max(255)
        .label(this.$t("syslogServerIp")),
        Port: Yup.string()
        .required()
        .max(255)
        .label(this.$t("connectionPort")),
      // username: Yup.string().required().max(255).label(this.$t("username")),
      // password: Yup.string().required().max(255).label(this.$t("password")),
    });
    return {
      schema,
      module: SyslogSetting,
      formValues: {
        IsEnabled: true,
        Port: "",
        HostName: "",
        username: "",
        password: "",
      },
    };
  },
  computed: {
    ...mapState({
      company: (state: any) => state.auth.company,
    }),
  },
  mounted() {
    store
      .dispatch(
        GeneralActionTypes.GET_GLOBAL_SETTINGS,
        "syslog-" + this.company.companyGuid
      )
      .then((response: any) => {
        if (response && response.data && response.data.entityData) {
          this.formValues.IsEnabled = response.data.entityData.IsEnabled;
          this.formValues.Port =
            response.data.entityData.Port;
          this.formValues.HostName =
            response.data.entityData.HostName;
          this.formValues.username = response.data.entityData.username;
          this.formValues.password = response.data.entityData.password;
        }
      });
  },
  methods: {
    async toggleStatus(value: any) {
      this.formValues.IsEnabled = value;
    },
    onSubmit(e: any) {
      Swal.fire({
        title: "Are You Sure?",
        text: "You are about to update the Syslog settings item!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Save",
      }).then((result) => {
        if (result.isConfirmed) {
          const formData: any = this.formValues;
          formData.settingsType = "syslog-" + this.company.companyGuid;
          formData.CompanyGuid = this.company.companyGuid;
          store
            .dispatch(GeneralActionTypes.UPDATE_GLOBAL_SETTINGS, formData)
            .then((response: any) => {
              if (Number(response.status) != 200) {
                Swal.fire("Error", response.Errors, "error");
              } else {
                Swal.fire(
                  "Success!",
                  "Syslog settigns has been updated!",
                  "success"
                );
              }
            })
            .catch((e: any) => {
              Swal.fire("Error", JSON.stringify(e.Message), "error");
            });
        }
      });
    },
  },
  components: { AgCard, Toggle, Field, Form, ErrorMessage },
});
